const getTheme = {
    direction: 'ltr',
    palette: {
      primary: {
        main: '#f58113'
      },
      secondary: {
        main: '#1b4962'
      },
      text: {
        primary: '#828282'
      },
      mode: 'light'
    },
    transitionAnimations: {
      mobile: '',
      web: ''
    },
    spacing: 16,
    appBarIconPaddingUnit: 1,
    appSpacing: {
      horizontalUnit: 2,
      verticalUnit: 2
    },
    zIndex: {
      menu: 1600,
      drawer:1000,
    },
    typography: {
      h1: {
        fontSize: '2rem',
        fontWeight: 500
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 500
      },
      h3: {
        fontSize: '1.25rem',
        fontWeight: 500
      },
      body1: {
        fontSize: '1rem',
        fontWeight: 400
      },
      htmlFontSize: 19,
      fontFamily: [
        'montserrat',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(','),
      useNextVariants: true
    }
}
export default getTheme
